<template>
  <div>
    <v-container class="content-wrapper" fluid id="overview-provider-tab">
      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <!-- Back to the Providers -->
            <v-card-text>
              <v-row>
                <v-col cols="12" md="auto">
                  <v-btn
                    depressed
                    rounded
                    small
                    color="blue"
                    class="white--text font-weight-bold"
                    @click="goBack"
                  >
                    <v-icon color="black" small class="mr-2">
                      mdi-arrow-left
                    </v-icon>
                    Back
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- Logo Hosting and Logo Equipment -->
            <v-card-text>
              <v-row align="center" justify="start">
                <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                  <v-img
                    :src="provider.logoUrl"
                    class="resource-image"
                    lazy-src="@/assets/img/blur.jpg"
                    contain
                    style="max-width: 200px; border-radius: 19.875px;"
                  ></v-img>
                  <!-- <v-card-text class="mt-5">
                    <v-icon>mdi-eye</v-icon>
                    {{ provider.views }} registered views
                  </v-card-text>
                  <v-card-text class="pt-0">
                    <v-icon>mdi-eye</v-icon>
                    {{ provider.nonRegisteredViews }} non registered views
                  </v-card-text> -->
                </v-col>
              </v-row>
            </v-card-text>

            <!-- Main Body -->
            <v-card-text>
              <v-row align="center" no-gutters>
                <v-col cols="auto">
                  <h2 class="black--text">
                    {{ provider.name }}
                  </h2>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-if="provider.description">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <h3 class="primary200--text">
                    Description
                  </h3>
                  <div v-html="provider.description"></div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text
              v-if="
                provider.hostingInstitution &&
                  provider.hostingInstitution.name &&
                  provider.hostingInstitution.id
              "
            >
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <h3 class="primary200--text">
                    Hosting Institution Entity:
                  </h3>
                  <router-link
                    :to="{
                      name: 'OverviewHostingInstitution',
                      params: { id: provider.hostingInstitution.id },
                    }"
                    style="text-decoration: underline; color: inherit;"
                  >
                    {{ provider.hostingInstitution.name }}
                  </router-link>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-if="provider.socialMedia.length" class="mt-0 pt-0">
              <v-row>
                <v-col cols="12">
                  <div>
                    <social-media :list="provider.socialMedia"></social-media>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-if="provider.tags.length">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <h3 class="primary200--text">
                    Tags
                  </h3>
                </v-col>
              </v-row>
              <v-row v-if="provider.tags.length > 0">
                <v-chip
                  :color="color(index)"
                  v-for="(tag, index) in provider.tags"
                  :key="index"
                  class="ma-2"
                >
                  {{ tag }}
                </v-chip>
              </v-row>
            </v-card-text>
            <!-- <v-card-actions>
              <v-row>
                <v-col cols="auto">
                  <v-btn
                    :disabled="!provider.contactInfo.verified"
                    @click.stop=""
                    :href="'mailto:' + provider.contactInfo.email"
                    outlined
                    class="black--text font-weight-bold mb-2"
                    rounded
                    large
                  >
                    <v-icon color="black" small class="mr-2">
                      mdi-email-outline
                    </v-icon>
                    Contact
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions> -->

            <!-- Overview Provider Tabs -->
            <v-card-text>
              <v-tabs v-model="tab" show-arrows active-class="primary200--text">
                <v-tabs-slider color="primary200"></v-tabs-slider>
                <v-tab v-show="resourcesTab">{{ $t('Resources') }}</v-tab>
                <v-tab v-show="classificationTab">{{ $t('classification') }}</v-tab>
                <!-- <v-tab v-show="contactTab">{{ $t('contact') }}</v-tab> -->
                <v-tab v-show="locationTab">{{ $t('location') }}</v-tab>
                <v-tab v-show="additionalInfoTab">{{ $t('additional-information') }}</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <!-- Resources Info -->
                <v-tab-item
                  v-show="resourcesTab"
                  :transition="false"
                  :reverse-transition="false"
                  :key="0"
                >
                  <v-row class="mt-1">
                    <v-col cols="12" class="d-flex justify-end" v-if="paginatedResources.length">
                      <v-btn :disabled="currentPage === 1" @click="currentPage--" small plain>
                        <v-icon color="black" small class="mr-2">
                          mdi-arrow-left
                        </v-icon>
                      </v-btn>
                      <span> {{ currentPage }} / {{ totalPages }}</span>
                      <v-btn
                        :disabled="currentPage === totalPages"
                        @click="currentPage++"
                        small
                        plain
                      >
                        <v-icon color="black" small class="mr-2">
                          mdi-arrow-right
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="ma-5">
                    <v-col
                      cols="12"
                      xl="3"
                      lg="3"
                      md="3"
                      sm="6"
                      class="pa-3"
                      v-for="(resource, index) in paginatedResources"
                      :key="'resource-' + index"
                    >
                      <v-hover v-slot="{ hover }">
                        <v-card
                          class="d-flex justify-center align-center"
                          elevation="3"
                          style="border-radius: 24px; height: 100%;"
                          :class="{ 'on-hover': hover }"
                          @click="redirect(resource)"
                        >
                          <v-card-text>
                            <v-row align="center">
                              <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                                <v-img
                                  v-if="resource.logo"
                                  height="120px"
                                  max-width="80%"
                                  contain
                                  v-bind:src="resource.logo"
                                  :style="{
                                    borderTopLeftRadius: '24px',
                                    borderTopRightRadius: '24px',
                                  }"
                                ></v-img>
                                <v-img
                                  v-else
                                  height="120px"
                                  max-width="80%"
                                  contain
                                  :src="require('@/assets/img/blur.jpg')"
                                />
                              </v-col>
                              <v-col cols="12" xl="6" lg="12" md="12" sm="12" align="center">
                                <div class="mt-0 pt-0">
                                  <span class="text-bold black--text">
                                    {{ resource.name }}
                                  </span>
                                </div>
                                <div>
                                  <v-chip
                                    depressed
                                    rounded
                                    small
                                    color="blue"
                                    class="white--text font-weight-bold"
                                  >
                                    {{ resource.label }}
                                  </v-chip>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <!-- Classification Info -->
                <v-tab-item
                  v-show="classificationTab"
                  :transition="false"
                  :reverse-transition="false"
                  :key="1"
                >
                  <v-row v-if="provider.classificationInfo.domains.length" class="mt-10">
                    <v-col cols="12" md="2" sm="12">
                      <label v-if="provider.classificationInfo.domains.length > 1"
                        >Scientific domains</label
                      >
                      <label v-else>Scientific Domain</label>
                      <p>
                        <span
                          v-for="(domain, index) in provider.classificationInfo.domains"
                          :key="index"
                        >
                          {{ domain.domain }}
                          <span v-if="index < provider.classificationInfo.domains.length - 1"
                            >/
                          </span>
                        </span>
                      </p>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                      <label v-if="provider.classificationInfo.domains.length > 1"
                        >Scientific Subdomains</label
                      >
                      <label v-else>Scientific Subdomain</label>
                      <p>
                        <span
                          v-for="(subdomain, index) in provider.classificationInfo.domains"
                          :key="index"
                        >
                          {{ subdomain.subDomain }}
                          <span v-if="index < provider.classificationInfo.domains.length - 1"
                            >/
                          </span>
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row v-if="provider.classificationInfo.structureTypes.length" class="mt-0 pt-0">
                    <v-col cols="12" md="2" sm="12">
                      <label v-if="provider.classificationInfo.structureTypes.length > 1"
                        >Structure Types</label
                      >
                      <label v-else>Structure Type</label>
                      <p>
                        <span
                          v-for="(type, index) in provider.classificationInfo.structureTypes"
                          :key="index"
                        >
                          {{ type.name }}
                          <span v-if="index < provider.classificationInfo.structureTypes.length - 1"
                            >,
                          </span>
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="provider.classificationInfo.areasOfActivity.length"
                    class="mt-0 pt-0"
                  >
                    <v-col cols="12" md="2" sm="12">
                      <label>Areas of Activity</label>
                      <p>
                        <span>
                          <span
                            v-for="(activity, index) in provider.classificationInfo.areasOfActivity"
                            :key="index"
                          >
                            {{ activity.name }}
                            <span
                              v-if="index < provider.classificationInfo.areasOfActivity.length - 1"
                              >,
                            </span>
                          </span>
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <!-- Contact Info -->
                <!-- <v-tab-item
                  v-show="contactTab"
                  :transition="false"
                  :reverse-transition="false"
                  :key="2"
                >
                  <v-row v-if="provider.contactInfo.email">
                    <v-col cols="12" lg="5" xl="4" md="6" sm="12">
                      <v-card class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6 custom-card">
                        <v-row align="center">
                          <v-col cols="12" lg="3" xl="3" md="12" sm="12">
                            <v-card-text>
                              <v-avatar :size="80" class="white--text text-bold" :color="'primary'">
                                {{ letters }}
                              </v-avatar>
                            </v-card-text>
                          </v-col>
                          <v-col cols="12" lg="9" xl="9" md="12" sm="12">
                            <v-card-title class="black--text text-bold">
                              {{ provider.contactInfo.lastname }}
                              {{ provider.contactInfo.firstname }}
                            </v-card-title>
                            <v-card-text class="mt-0 pt-0 primary200--text text-bold">
                              {{ provider.contactInfo.email }}
                            </v-card-text>
                            <v-card-text class="mt-0 pt-0 primary200--text text-bold">
                              {{ provider.contactInfo.phone }}
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item> -->

                <!-- Location Info -->
                <v-tab-item
                  v-show="locationTab"
                  :transition="false"
                  :reverse-transition="false"
                  :key="3"
                >
                  <v-row class="mt-10">
                    <v-col cols="12" xl="6" lg="6">
                      <div v-if="provider.locationInfo.city" class="label-marketplace">
                        {{ $t('city') }}
                      </div>
                      <div v-if="provider.locationInfo.city">
                        {{ provider.locationInfo.city }}
                      </div>
                      <div v-if="provider.locationInfo.street" class="label-marketplace mt-6">
                        {{ $t('street-name-number') }}
                      </div>
                      <div v-if="provider.locationInfo.street">
                        {{ provider.locationInfo.street }}
                      </div>
                      <div v-if="provider.locationInfo.poBox" class="label-marketplace mt-6">
                        {{ $t('po-box') }}
                      </div>
                      <div v-if="provider.locationInfo.poBox">
                        {{ provider.locationInfo.poBox }}
                      </div>
                      <div
                        v-if="provider.locationInfo.country.description"
                        class="label-marketplace mt-6"
                      >
                        {{ $t('country') }}
                      </div>
                      <div v-if="provider.locationInfo.country.description">
                        {{ provider.locationInfo.country.description }}
                      </div>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" v-if="markerLatLng != null">
                      <div>
                        <l-map
                          ref="map"
                          style="height: 400px; border-radius: 24px; z-index: 1; "
                          :zoom="2"
                          :center="[0, 0]"
                          :options="{ attributionControl: false, scrollWheelZoom: false }"
                          @ready="onMapReady"
                        >
                          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                          <l-marker :lat-lng="markerLatLng"></l-marker>
                          <l-control-attribution
                            position="bottomright"
                            prefix=""
                          ></l-control-attribution>
                        </l-map>
                      </div>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <!-- Addition Info -->
                <v-tab-item
                  v-show="additionalInfoTab"
                  :transition="false"
                  :reverse-transition="false"
                  :key="4"
                >
                  <v-row v-if="provider.additionalInfo.certifications.length" class="mt-10">
                    <v-col cols="12" md="2" sm="12">
                      <label v-if="provider.additionalInfo.certifications.length > 1"
                        >Certifications</label
                      >
                      <label v-else>Certification</label>
                      <p>
                        <span
                          v-for="(certification, index) in provider.additionalInfo.certifications"
                          :key="index"
                        >
                          {{ certification.certification }}
                          <span v-if="index < provider.additionalInfo.certifications.length - 1"
                            >,
                          </span>
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row v-if="provider.additionalInfo.certifications.length" class="mt-0 pt-0">
                    <v-col cols="12" md="2" sm="12">
                      <label v-if="provider.additionalInfo.certifications.length > 1"
                        >Certification Documents</label
                      >
                      <label v-else>Certification Document</label>
                      <p>
                        <span
                          v-for="(certification, index) in provider.additionalInfo.certifications"
                          :key="index"
                        >
                          <v-btn @click="downloadCertification(certification)" icon raised small>
                            <v-icon>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          {{ certification.certificationDocument }}
                          <span v-if="index < provider.additionalInfo.certifications.length - 1"
                            >,
                          </span>
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import SocialMedia from '@/components/marketplace/SocialMedia';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControlAttribution } from 'vue2-leaflet';

export default {
  name: 'OverviewProvider',
  mixins: [util],
  components: { SocialMedia, LMap, LTileLayer, LMarker, LControlAttribution },
  data() {
    return {
      provider: {
        logoUrl: null,
        views: null,
        email: null,
        nonRegisteredViews: null,
        name: '',
        description: '',
        hostingInstitution: {
          name: '',
          id: null,
        },
        socialMedia: [],
        tags: [],

        classificationInfo: {
          domains: [],
          structureTypes: [],
          areasOfActivity: [],
        },
        contactInfo: {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
        },
        additionalInfo: {
          certifications: [],
        },
        locationInfo: {
          city: '',
          street: '',
          poBox: '',
          country: {
            id: null,
            description: '',
          },
          coordinates: null,
        },
      },
      map: null,
      url: process.env.VUE_APP_MAPTILE_PREFIX + '/{z}/{x}/{y}.png',
      attribution:
        '<a href="https://leafletjs.com/">Leaflet</a> | &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      letters: '',
      marketplaceProvidersViewAll: '',
      marketplaceEquipmentViewAll: '',
      marketplaceServicesViewAll: '',
      marketplacePatentsViewAll: '',
      ordersQuery: '',
      equipmentFavoriteQuery: '',
      patentFavoriteQuery: '',
      serviceQuery: '',
      ordersadminQuery: '',
      ordersServicesQuery: '',
      patentOrdersQuery: '',
      patentOrdersadminQuery: '',
      equipmentOrdersadminQuery: '',
      tab: null,
      resources: [],
      currentPage: 1,
      itemsPerPage: 8,
      isVerified: {
        verified: false,
      },
      providerSearchMarketplaceQuery: '',
    };
  },
  mounted() {
    this.getProvider();
    this.marketplaceProvidersViewAll = this.$route.query.marketplaceProvidersViewAll;
    this.marketplaceEquipmentViewAll = this.$route.query.marketplaceEquipmentViewAll;
    this.marketplaceServicesViewAll = this.$route.query.marketplaceServicesViewAll;
    this.marketplacePatentsViewAll = this.$route.query.marketplacePatentsViewAll;
    this.ordersQuery = this.$route.query.ordersQuery;
    this.ordersServicesQuery = this.$route.query.ordersServicesQuery;
    this.ordersadminQuery = this.$route.query.ordersadminQuery;
    this.patentOrdersQuery = this.$route.query.patentOrdersQuery;
    this.patentOrdersadminQuery = this.$route.query.patentOrdersadminQuery;
    this.equipmentOrdersadminQuery = this.$route.query.equipmentOrdersadminQuery;
    this.equipmentFavoriteQuery = this.$route.query.equipmentFavoriteQuery;
    this.patentFavoriteQuery = this.$route.query.patentFavoriteQuery;
    this.serviceQuery = this.$route.query.serviceQuery;
    this.providerSearchMarketplaceQuery = this.$route.query.providerSearchMarketplace;

    this.getOtherResources();
  },
  beforeUpdate() {
    const { firstname, lastname } = this.provider.contactInfo;
    this.letters = '';

    if (lastname && firstname) {
      this.letters = lastname.charAt(0) + firstname.charAt(0);
    }
  },
  computed: {
    resourcesTab() {
      return this.resources.length > 0;
    },
    classificationTab() {
      if (
        this.provider.classificationInfo.domains.length ||
        this.provider.classificationInfo.structureTypes.length ||
        this.provider.classificationInfo.areasOfActivity.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    contactTab() {
      return this.provider.contactInfo.email;
    },
    locationTab() {
      if (this.provider.locationInfo.country.id || this.markerLatLng) {
        return true;
      } else {
        return false;
      }
    },
    additionalInfoTab() {
      if (this.provider.additionalInfo.certifications.length) {
        return true;
      } else {
        return false;
      }
    },
    totalPages() {
      return Math.ceil(this.resources.length / this.itemsPerPage);
    },
    paginatedResources() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.resources.slice(start, end);
    },
    markerLatLng() {
      if (this.provider.locationInfo == null || this.provider.locationInfo.coordinates == null) {
        return null;
      } else {
        const coordinates = this.provider.locationInfo.coordinates.split(',');
        try {
          return L.latLng(coordinates[0].trim(), coordinates[1].trim());
        } catch (e) {
          console.log(e);
          return null;
        }
      }
    },
  },
  methods: {
    getProvider() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/providers/${id}`)
        .then(response => {
          console.log('Get Provider', response.data);

          this.provider.logoUrl = response.data.logoUrl;
          this.provider.views = response.data.views;
          this.provider.nonRegisteredViews = response.data.viewsNonRegistered;
          this.provider.name = response.data.name;
          this.provider.description = response.data.description;
          this.provider.hostingInstitution.name = response.data.hostingInstitution.name;
          this.provider.hostingInstitution.id = response.data.hostingInstitution.id;
          this.provider.socialMedia = response.data.socialMedia;
          this.provider.tags = response.data.tags;

          this.provider.classificationInfo = {
            domains: response.data.scientifics,
            structureTypes: response.data.structureTypes,
            areasOfActivity: response.data.areasOfActivities,
          };

          const verifiedContact = response.data.publicContacts?.find(
            contact => contact.verified === true,
          );

          this.isVerified.verified = verifiedContact ? verifiedContact.verified : false;

          this.provider.contactInfo = {
            firstname: verifiedContact?.firstname,
            lastname: verifiedContact?.lastname,
            email: verifiedContact?.email,
            phone: verifiedContact?.phone,
            verified: verifiedContact ? verifiedContact.verified : false,
          };

          // this.provider.contactInfo = {
          //   firstname:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].firstname
          //       : '-',
          //   lastname:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].lastname
          //       : '-',
          //   email:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].email
          //       : '-',
          //   phone:
          //     response.data.publicContactsVerified &&
          //     response.data.publicContactsVerified.length > 0
          //       ? response.data.publicContactsVerified[0].phone
          //       : '-',
          // };

          this.provider.additionalInfo = {
            certifications: response.data.certifications,
          };

          this.provider.locationInfo = {
            city: response.data.city,
            street: response.data.street,
            poBox: response.data.poBox,
            coordinates: response.data.coordinates,
            country: {
              id: response.data.country?.id,
              description: response.data.country?.description,
            },
          };
        })
        .catch(error => {
          console.error('Error fetching provider data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getOtherResources() {
      EventBus.$emit('waiting', true);

      const providerId = this.$route.params.id;

      this.axios
        .get(`api/v1/equipment/other-resources`, {
          params: {
            providerId,
          },
        })
        .then(response => {
          console.log('Response data from Other Resources:', response.data);

          this.resources = response.data.filter(resource => resource.id);

          this.currentPage = 1;
        })
        .catch(error => {
          console.error('Error fetching other resources:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    redirect(resource) {
      const id = resource.id;
      const label = resource.label;

      if (id && label === 'Service' && this.$store.getters.roles != null) {
        this.$router.push({ name: 'OverviewService', params: { id: id } });
      }

      if (id && label === 'Equipment' && this.$store.getters.roles != null) {
        this.$router.push({ name: 'OverviewEquipment', params: { id: id } });
      }

      if (id && label === 'Patent' && this.$store.getters.roles != null) {
        this.$router.push({ name: 'OverviewPatent', params: { id: id } });
      }
    },
    goBack() {
      if (this.marketplaceProvidersViewAll && this.$route.query.fromTable) {
        const marketplaceProvidersViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Providers';
        let routePath = '';
        routePath = '/marketplace/providers';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceProvidersViewAll, ...fromTable },
        });
      } else if (this.marketplaceProvidersViewAll && this.$route.query.filters) {
        const marketplaceProvidersViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Providers';
        let routePath = '';
        routePath = '/marketplace/providers';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceProvidersViewAll, ...filters },
        });
      } else if (this.marketplaceEquipmentViewAll && !this.$store.getters.roles) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/equipment';
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll },
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/marketplace/equipment';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...fromTable },
        });
      } else if (this.marketplaceServicesViewAll && !this.$store.getters.roles) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/public-catalogue-marketplace/services';
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll },
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/marketplace/equipment';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...fromTable },
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplaceEquipmentViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Equipment';
        let routePath = '';
        routePath = '/marketplace/equipment';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceEquipmentViewAll, ...filters },
        });
      } else if (
        this.marketplaceEquipmentViewAll &&
        this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 1);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'SearchMarketplace',
          query: searchBar,
        });
      } else if (
        this.marketplaceServicesViewAll &&
        this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/marketplace/services';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...fromTable },
        });
      } else if (
        this.marketplaceServicesViewAll &&
        this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/marketplace/services';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...filters },
        });
      } else if (
        this.marketplaceServicesViewAll &&
        this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 0);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'SearchMarketplace',
          query: searchBar,
        });
      } else if (
        this.marketplaceServicesViewAll &&
        this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplaceServicesViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Services';
        let routePath = '';
        routePath = '/marketplace/services';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplaceServicesViewAll, ...fromTable },
        });
      } else if (
        this.marketplacePatentsViewAll &&
        this.$store.getters.roles &&
        this.$route.query.fromTable
      ) {
        const marketplacePatentsViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Patents';
        let routePath = '';
        routePath = '/marketplace/patents';
        const fromTable = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplacePatentsViewAll, ...fromTable },
        });
      } else if (
        this.marketplacePatentsViewAll &&
        this.$store.getters.roles &&
        this.$route.query.filters
      ) {
        const marketplacePatentsViewAll = true;
        const selectedCatalogue = 'Browse the Catalogue of Patents';
        let routePath = '';
        routePath = '/marketplace/patents';
        const filters = this.$route.query;
        this.$router.push({
          path: routePath,
          query: { selectedCatalogue, marketplacePatentsViewAll, ...filters },
        });
      } else if (
        this.marketplacePatentsViewAll &&
        this.$store.getters.roles &&
        this.$route.query.searchBar
      ) {
        localStorage.setItem('tabIndex', 2);
        const searchBar = this.$route.query;
        this.$router.push({
          name: 'SearchMarketplace',
          query: searchBar,
        });
      } else if (this.ordersQuery) {
        this.$router.push({
          name: 'MyOrders',
          query: { toggleOrder: 'equipment' },
        });
      } else if (this.ordersServicesQuery) {
        this.$router.push({
          name: 'MyOrders',
          query: { toggleOrder: 'services' },
        });
      } else if (this.patentOrdersQuery) {
        this.$router.push({
          name: 'MyOrders',
          query: { toggleOrder: 'patents' },
        });
      } else if (this.ordersadminQuery) {
        this.$router.push({
          name: 'Orders',
          query: { toggleOrder: 'services' },
        });
      } else if (this.patentOrdersadminQuery) {
        this.$router.push({
          name: 'Orders',
          query: { toggleOrder: 'patents' },
        });
      } else if (this.equipmentOrdersadminQuery) {
        this.$router.push({
          name: 'Orders',
          query: { toggleOrder: 'equipment' },
        });
      } else if (this.equipmentFavoriteQuery) {
        this.$router.push({
          name: 'MyFavorites',
          query: { toggleOrder: 'equipment' },
        });
      } else if (this.patentFavoriteQuery) {
        this.$router.push({
          name: 'MyFavorites',
          query: { toggleOrder: 'intellectualProperties' },
        });
      } else if (this.serviceQuery) {
        this.$router.push({
          name: 'MyFavorites',
          query: { toggleOrder: 'services' },
        });
      } else if (this.providerSearchMarketplaceQuery && this.$route.query.filters) {
        localStorage.setItem('tabIndex', 3);
        const filters = this.$route.query;
        this.$router.push({
          name: 'SearchMarketplace',
          query: filters,
        });
      } else if (this.$route.query.fromTable && this.$store.getters.roles === 'super-admin') {
        const fromTable = this.$route.query.fromTable;
        const providersEnabled = this.$route.query.providersEnabled;
        const filters = this.$route.query;
        this.$router.push({
          name: 'AdminProviders',
          query: { fromTable, providersEnabled, ...filters },
        });
      } else {
        this.$router.go(-1);
      }
    },
    downloadCertification(certification) {
      const providerId = this.$route.params.id;
      const certificationId = certification.id;
      const certificationFile = certification.certificationDocument;

      const filePath = `api/v1/provider-settings/${providerId}/file/${certificationFile}?certificationId=${certificationId}`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = certification.certificationDocument;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
    onMapReady(map) {
      this.map = map;
      if (this.markerLatLng) {
        this.map.flyTo(this.markerLatLng, 15, {
          duration: 2,
          easeLinearity: 0.25,
        });
      }
    },
  },
  watch: {
    resources(val) {
      if (val.length > 0) {
        this.tab = 0;
      } else {
        this.$nextTick(() => {
          if (this.classificationTab) this.tab = 1;
          else if (this.contactTab) this.tab = 2;
          else if (this.locationTab) this.tab = 3;
        });
      }
    },
    classificationTab(val) {
      if (val && !this.resourcesTab) {
        this.tab = 1;
      }
    },
  },
};
</script>
